import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import axios from 'axios'
import GenericModal from "../../../components/Modals/GenericModal";
import { GoogleLogin } from 'react-google-login';
import {SIGNIN_WITH_GOOGLE} from "../../../api/Api";


/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  email: "",
  password: "",
};

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [loginResponseError, setLoginResponseError] = useState(false);
  const [isGoogleSignin,setIsGoogleSignin] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Mauvais format d'adresse email")
      .required(
          "Champs requis"
      ),
    password: Yup.string()
      .required(
          "Champs requis"
      ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  async function onGoogleSignin(userInfo){

    setIsGoogleSignin(true)

    console.log(userInfo);

    try{

      const response = await axios.post(
          SIGNIN_WITH_GOOGLE,{
            email: userInfo.profileObj.email,
            google_id: userInfo.profileObj.googleId,
          }
      );


      const accessToken = response.data.token;
      props.login(accessToken);

      console.log('google login response');

    } catch (e) {

      console.log(e)

    } finally {
      setIsGoogleSignin(false)
    }

  }

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();

      console.log('doUserLogin');
      setLoginResponseError();

      login(values.email, values.password)
          .then((response) => {

            console.log(response);

            switch (response.status) {

              case (200):
                const accessToken = response.data.token;
                  props.login(accessToken);
                break;

              default:
                  // TODO: Display some alert message
                break;

            }

            // disableLoading();

          })
          .catch((error) => {

            console.log('error response=>', error.response);

            if(error.response){

              setLoginResponseError(error.response);

              switch (error.response.status) {
                case 401:
                  setStatus(
                      intl.formatMessage({
                        id: "AUTH.VALIDATION.INVALID_LOGIN",
                      })
                  );
                  break;
              }

            }

          }).finally(
          () => {
            disableLoading();
            setSubmitting(false);
          }
      );

    },
  });

  return (

    <div className="login-form login-signin" id="kt_login_signin_form">

      {/* begin::Head */}

      <div className="pb-13 pt-lg-0 pt-5">
        {/*<h3 className="font-weight-bolder text-primary font-size-h4 font-size-h1-lg ">Bienvenue dans PGT</h3>*/}
      </div>
      {/* end::Head */}

      {/*begin::Form*/}


      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        {formik.status && (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">Identifiants incorrects</div>
          </div>
        ) }

        <div className="text-center pb-8">
          <h2 className="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">Connectez vous</h2>
          <span className="text-muted font-weight-bold font-size-h4">Ou</span>
          <div>

            <Link
                to="/auth/registration"
                className="text-primary font-weight-bolder d-inline-block ml-3"
            >
              Créez un compte
            </Link>

          </div>
        </div>

        <div className="form-group fv-plugins-icon-container mb-5">
          <label className="font-size-h6 mb-5 text-dark font-weight-bold">Email</label>
          <input
            placeholder="Email"
            type="email"
            className={`form-control form-control-solid h-auto py-7 px-6 ${getInputClasses(
              "email"
            )}`}
            name="email"
            {...formik.getFieldProps("email")}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.email}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group mt-5 pt-5 fv-plugins-icon-container">

          <div className="mt-5 pt-5 d-flex justify-content-between mt-n5 mb-5">
            <label className="font-size-h6 text-dark font-weight-bold">Mot de passe</label>

            <Link
                to="/auth/forgot-password"
                className="text-primary font-size-h6 font-weight-bolder text-hover-primary"
                id="kt_login_forgot"
            >
              Mot de passe oublié ?
            </Link>

          </div>

          <input
            placeholder="Mot de passe"
            type="password"
            className={`form-control form-control-solid h-auto py-7 px-6 ${getInputClasses(
              "password"
            )}`}
            name="password"
            {...formik.getFieldProps("password")}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group d-flex flex-wrap justify-content-center align-items-center">

          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={`btn btn-primary font-weight-bold px-9 py-4 my-3 mr-2`}
          >
            <span>Connexion</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>


          <GoogleLogin
              clientId="126890637107-4fh26l8pcqkkdnnlh948ccaamkf3k6tc.apps.googleusercontent.com"
              buttonText="Login"
              render={(renderProps)=>{
                return <button onClick={renderProps.onClick}
                               disabled={renderProps.disabled}
                               type="button"
                               className="btn btn-light-primary font-weight-bolder px-8 py-4 my-3 font-size-lg">
									<span className="svg-icon svg-icon-md">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                           fill="none">
											<path
                                                d="M19.9895 10.1871C19.9895 9.36767 19.9214 8.76973 19.7742 8.14966H10.1992V11.848H15.8195C15.7062 12.7671 15.0943 14.1512 13.7346 15.0813L13.7155 15.2051L16.7429 17.4969L16.9527 17.5174C18.879 15.7789 19.9895 13.221 19.9895 10.1871Z"
                                                fill="#4285F4"></path>
											<path
                                                d="M10.1993 19.9313C12.9527 19.9313 15.2643 19.0454 16.9527 17.5174L13.7346 15.0813C12.8734 15.6682 11.7176 16.0779 10.1993 16.0779C7.50243 16.0779 5.21352 14.3395 4.39759 11.9366L4.27799 11.9466L1.13003 14.3273L1.08887 14.4391C2.76588 17.6945 6.21061 19.9313 10.1993 19.9313Z"
                                                fill="#34A853"></path>
											<path
                                                d="M4.39748 11.9366C4.18219 11.3166 4.05759 10.6521 4.05759 9.96565C4.05759 9.27909 4.18219 8.61473 4.38615 7.99466L4.38045 7.8626L1.19304 5.44366L1.08875 5.49214C0.397576 6.84305 0.000976562 8.36008 0.000976562 9.96565C0.000976562 11.5712 0.397576 13.0882 1.08875 14.4391L4.39748 11.9366Z"
                                                fill="#FBBC05"></path>
											<path
                                                d="M10.1993 3.85336C12.1142 3.85336 13.406 4.66168 14.1425 5.33717L17.0207 2.59107C15.253 0.985496 12.9527 0 10.1993 0C6.2106 0 2.76588 2.23672 1.08887 5.49214L4.38626 7.99466C5.21352 5.59183 7.50242 3.85336 10.1993 3.85336Z"
                                                fill="#EB4335"></path>
										</svg>
									</span>Connectez vous avec Google
                  {isGoogleSignin && <span className="ml-3 spinner spinner-white"></span>}
                </button>
              }}
              onSuccess={onGoogleSignin}
              onFailure={(...args)=>{
                console.error(args)
              }}
              cookiePolicy={'single_host_origin'}
          />


        </div>
      </form>

      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
